export default __webpack_public_path__ + "static/media/hero-mobile-safari-EN.b13911d6.png";